var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25.2188,
    r: 25,
    fill: "#D2F5EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_300_8262)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5956 14.6898C25.9351 14.6898 27.8531 16.6029 27.8531 18.9362V22.1592H30.168V18.9362C30.168 15.3274 27.2123 12.3809 23.5956 12.3809C19.9789 12.3809 17.0233 15.3274 17.0233 18.9362V22.1592H19.3382V18.9362C19.3382 16.6028 21.2562 14.6898 23.5956 14.6898Z",
    fill: "#DEDBEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.168 18.9362C30.168 15.3274 27.2123 12.3809 23.5956 12.3809C22.8553 12.3809 22.1423 12.5047 21.477 12.7321C21.7425 12.699 22.0124 12.6817 22.2866 12.6817C25.9033 12.6817 28.859 15.6298 28.859 19.2371V22.1592H30.168V18.9362Z",
    fill: "#D2CFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8531 21.6525V18.9362C27.8531 16.6028 25.9351 14.6898 23.5956 14.6898C21.2562 14.6898 19.3382 16.6029 19.3382 18.9362V21.6525M17.0233 21.6525V18.9362C17.0233 15.3274 19.979 12.3809 23.5957 12.3809C27.2124 12.3809 30.168 15.3274 30.168 18.9362V21.6525",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7448 21.6526C15.3795 21.6526 14.2625 22.7667 14.2625 24.1285V27.8121C14.2625 32.9323 18.4622 37.1212 23.5957 37.1212C25.342 37.1212 26.98 36.6361 28.3799 35.7954L32.9289 27.0003V24.1285C32.9289 22.7668 31.8119 21.6526 30.4466 21.6526C25.8788 21.6526 21.3125 21.6526 16.7448 21.6526Z",
    fill: "#FDB441"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5956 25.2742C22.48 25.2742 21.5751 26.1753 21.5751 27.288C21.5751 28.0063 21.9518 28.6353 22.5175 28.9938L22.0673 31.9203H25.124L24.6737 28.9938C25.2395 28.6354 25.6161 28.0063 25.6161 27.288C25.6161 26.1753 24.7112 25.2742 23.5956 25.2742Z",
    fill: "#025F80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4007 26.9741C29.4536 26.9741 27.0651 29.3565 27.0651 32.2958C27.0651 33.636 27.5616 34.8595 28.3799 35.7952C29.3584 36.9122 30.7972 37.619 32.4007 37.619C35.3477 37.619 37.7376 35.2352 37.7376 32.2958C37.7376 29.5349 35.6291 27.2648 32.9289 27C32.7557 26.9828 32.5796 26.9741 32.4007 26.9741Z",
    fill: "#2CCDAD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2637 25.3001C24.0229 25.5952 24.5626 26.3409 24.5626 27.2132C24.5626 27.943 24.1859 28.5821 23.6202 28.9463L24.0705 31.9203H25.1241L24.6738 28.9938C25.2395 28.6354 25.6162 28.0063 25.6162 27.288C25.6162 26.1753 24.7113 25.2742 23.5957 25.2742C23.4831 25.2742 23.3719 25.2829 23.2637 25.3001Z",
    fill: "#024C67"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7376 32.2958C37.7376 29.5349 35.6291 27.2649 32.9289 27C32.7557 26.9828 32.5796 26.9741 32.4006 26.9741C32.0239 26.9741 31.6545 27.013 31.2995 27.0878C33.9925 27.3584 36.0953 29.6256 36.0953 32.3836C36.0953 34.9459 34.2783 37.085 31.8609 37.5917C32.0385 37.6089 32.2188 37.619 32.4007 37.619C35.3476 37.619 37.7376 35.2353 37.7376 32.2958Z",
    fill: "#028369"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9288 24.1285C32.9288 22.7667 31.8118 21.6526 30.4465 21.6526H30.168H28.859H27.8531C29.2183 21.6526 30.3354 22.7667 30.3354 24.1285V27.3875C30.6428 27.2593 30.9661 27.1572 31.2995 27.0881C31.6545 27.0132 32.024 26.9744 32.4006 26.9744C32.5796 26.9744 32.7556 26.983 32.9288 27.0003V24.1285Z",
    fill: "#FE9901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5956 25.2742C24.7112 25.2742 25.6161 26.1753 25.6161 27.288C25.6161 28.0063 25.2394 28.6353 24.6737 28.9938L25.124 31.9203H22.0673L22.5175 28.9938C21.9518 28.6354 21.5751 28.0063 21.5751 27.288C21.5751 26.1753 22.4801 25.2742 23.5956 25.2742Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3813 35.7954C26.98 36.6361 25.342 37.1212 23.5956 37.1212C18.4622 37.1212 14.2625 32.9323 14.2625 27.8121V24.1285C14.2625 22.7667 15.3795 21.6526 16.7447 21.6526H22.7369M24.5006 21.6526H30.4465C31.8118 21.6526 32.9288 22.7667 32.9288 24.1285V27.0002",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7583 30.6507C30.7583 30.5729 30.7641 30.4966 30.7742 30.4218C30.8868 29.6143 31.5911 28.9953 32.4353 29.0126C33.2897 29.0298 33.9968 29.7121 34.0416 30.5643C34.0906 31.5072 33.3373 32.2888 32.4006 32.2888V34.0018",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4021 35.5723L32.4006 35.5812",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8441 36.3624C34.9147 37.1469 33.714 37.619 32.4007 37.619C29.4536 37.619 27.0651 35.2353 27.0651 32.2958C27.0651 29.3564 29.4536 26.9741 32.4007 26.9741C35.3477 26.9741 37.7376 29.3565 37.7376 32.2958C37.7376 33.328 37.4432 34.2895 36.9352 35.1042",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_300_8262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(13 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.a90c1276677b95eadc04ae7ed1c4f473.svg";
export { ForwardRef as ReactComponent };